import { MsalContext } from "@azure/msal-react";
import React, { Component } from "react";
import { CheckForInternalUser } from "../../Helpers/miscellaneous";
import { Tooltip } from "@progress/kendo-react-tooltip";

class SolutionCards extends Component {
	static contextType = MsalContext
	render() {
		return (
			<div class="card shadow-sm tiles-hover cursor-pointer">
				<span className="top-0 right-0 m-3 position-absolute">
					{this.props.solution.isSuperApp === true && (
						<span className="px-2 py-1 super-app">
							<i className="mx-1 fas fa-rocket"></i>SUPER APP</span>
					)}

					{this.props.solution.isFeaturedApp === true && (
						<span className="px-2 py-1 mx-1 featured-app">
							<i className="mx-1 fas fa-star"></i>FEATURED APP</span>
					)}
				</span>
				<Tooltip anchorElement="pointer" position="top" tooltipClassName="kendo-tool-tip-tile">
					<div onClick={() => this.props.selectSolutions(this.props.solution)}>
						<div className="m-1" style={{ height: 180 }} title="View Details">
							{
								this.props.solution.TilesImageName !== undefined &&
								<div title="View Details"
									style={{
										height: 180,
										backgroundImage: `url(${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_CONTAINER}/${this.props.solution.organizationId}/${this.props.solution._id}/ProjectImages/${this.props.solution.TilesImageName})`,
										backgroundSize: 'cover'
									}}
								></div>
							}
						</div>


						<div class="card-body minHeight"  >
							<h5 class="card-title" title="View Details">{this.props.solution.name}</h5>
							<p class="card-text text-justify three-line-truncate text-2" title="View Details">{this.props.solution.description}</p>
						</div>
					</div>
				</Tooltip>
				{
					this.props.userRole !== "App Participant" &&
					<div className="border-top text-end p-2">
						{
							CheckForInternalUser(this.props.user.email) &&
							<strong className="float-start">
								{this.props.solution.numberOfTimesCloned ? this.props.solution.numberOfTimesCloned.low : 0}
							</strong>
						}
						{
							this.props.isShowFromRuntime ?
								<button
									onClick={() => this.props.onCreate(this.props.solution)}
									className="btn  btn-color px-2 py-1">Use app</button>

								:
								<button
									onClick={() => this.props.UseSolutionTemplate(this.props.solution)}
									className="btn  btn-color px-2 py-1">Use app</button>


						}
					</div>
				}
			</div>
		);
	}

	goToDesginer = () => {
		localStorage.setItem();
	};
}

export default SolutionCards;
